import { Label } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectDailyrentActionType } from 'shared/selectors/dailyrentActionType';
import { EActionType } from 'shared/types/dailyrentActionButtonsType';
import { useIsDailyrentOnlineBookingEnabled } from 'shared/utils/featureToggles/useIsDailyrentOnlineBookingEnabled';

export function InstantBookingLabelContainer() {
  const isOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();
  const actionType = useSelector(selectDailyrentActionType);
  const isOnlineBooking =
    isOnlineBookingEnabled &&
    actionType &&
    [
      EActionType.OtaBooking,
      EActionType.OtaCheckDates,
      EActionType.PartnerBooking,
      EActionType.PartnerCheckDates,
    ].includes(actionType);

  if (!isOnlineBooking) {
    return null;
  }

  return (
    <Label data-testid="InstantBookingLabel" background="rgba(21, 34, 66, 0.1)" color="black_100">
      Мгновенная бронь
    </Label>
  );
}
